import { useState, type ReactNode } from "react";

/** JSON object editor: a monospace textarea that reports parse errors. */
export function JsonField({
  value,
  onChange,
  rows = 12,
  label,
  help,
}: {
  value: string;
  onChange: (text: string, valid: boolean) => void;
  rows?: number;
  label: string;
  help?: ReactNode;
}) {
  const [error, setError] = useState<string | null>(null);
  const check = (text: string) => {
    try {
      const v = JSON.parse(text || "{}");
      if (typeof v !== "object" || v === null || Array.isArray(v)) throw new Error("Must be a JSON object");
      setError(null);
      return true;
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      return false;
    }
  };
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <textarea
        className="input input-mono"
        rows={rows}
        spellCheck={false}
        value={value}
        onChange={(e) => onChange(e.target.value, check(e.target.value))}
        onBlur={() => {
          try {
            const pretty = JSON.stringify(JSON.parse(value || "{}"), null, 2);
            if (pretty !== value) onChange(pretty, true);
          } catch {
            /* leave as is */
          }
        }}
      />
      {error ? <span className="field-help error-text">{error}</span> : help && <span className="field-help muted">{help}</span>}
    </label>
  );
}
